import React, { useState, useContext, useEffect } from "react";
import styles from './index.module.scss'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Menu, ConfigProvider } from 'antd'
import { useIntl } from 'react-intl'
import MainContext from '../../stores/stores'
import accountApi from "@/api/accountApi";

const Mine: React.FC<any> = (props) => {
  const { commonStore, setCommonStore } = useContext(MainContext)
	const { isCst, distributorInfo, colorPrimary } = commonStore
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const intl = useIntl()
  const [selectedKeys, setSelectedKeys] = useState<string[]>([pathname])
  const [items, setItems] = useState<any[]>([])
  /* useEffect(() => {
    let _userInfo = JSON.stringify(commonStore.userInfo)
    if(_userInfo === '{}') {
      getUserInfo()
    }
    let _distributorInfo = JSON.stringify(commonStore.distributorInfo)
    if(_distributorInfo === '{}') {
      getDistributorInfo()
    }
    getIsCst()
  }, []) */
  useEffect(() => {
    setSelectedKeys([pathname])
  }, [pathname])
  
  useEffect(() => {
    let companyItems = commonStore.userInfo && commonStore.userInfo.is_repair_shop_admin ? [
      {
        label: intl.formatMessage({ id: '公司管理' }),
        key: '/mine/company',
        icon: <i className='icon iconfont icon-gongsiguanli'></i>,
      },
    ] : []
    
    let invitationItem  = distributorInfo.status ? [
      {
        label: intl.formatMessage({ id: '邀请码' }),
        key: '/mine/invitation',
        icon: <i className='icon iconfont icon-a-zu29081'></i>,
      },
      {
        label: intl.formatMessage({ id: '海报管理' }),
        key: '/mine/poster',
        icon: <i className='icon iconfont icon-a-zu29081'></i>,
      },

    ]: []
    const _items: any = commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status === 1 ? [
      {
        label: intl.formatMessage({ id: '订单列表' }),
        key: '/mine/order',
        icon: <i className='icon iconfont icon-wodedingdan'></i>
      },
      {
        label: intl.formatMessage({ id: '退款/售后' }),
        key: '/mine/aftersales',
        icon: <i className='icon iconfont icon-tuikuanshouhou'></i>,
        cstnot: istest ? 0 : 1
      },
      {
        label: intl.formatMessage({ id: '对账单' }),
        key: '/mine/reconciliation',
        icon: <i className='icon iconfont icon-duizhangdan'></i>,
        cstnot: istest ? 0 : 1
      },
      {
        label: intl.formatMessage({ id: '应付单' }),
        key: '/mine/copewith',
        icon: <i className='icon iconfont icon-yingfudan'></i>,
        cstnot: istest ? 0 : 1
      },
      {
        label: intl.formatMessage({ id: '地址管理' }),
        key: '/mine/address',
        icon: <i className='icon iconfont icon-dizhiguanli'></i>,
      },
      {
        label: intl.formatMessage({ id: '发票抬头管理' }),
        key: '/mine/invoice',
        icon: <i className='icon iconfont icon-fapiaotaitou'></i>,
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        label: intl.formatMessage({ id: '设置' }),
        key: '/mine/setting',
        icon: <i className='icon iconfont icon-shezhi'></i>,
      },
      ...invitationItem,
    ] : [
      {
        label: intl.formatMessage({ id: '地址管理' }),
        key: '/mine/address',
        icon: <i className='icon iconfont icon-dizhiguanli'></i>,
      },
      {
        label: intl.formatMessage({ id: '发票抬头管理' }),
        key: '/mine/invoice',
        icon: <i className='icon iconfont icon-fapiaotaitou'></i>,
        cstnot: istest ? 0 : 1
      },
      ...companyItems,
      {
        label: intl.formatMessage({ id: '设置' }),
        key: '/mine/setting',
        icon: <i className='icon iconfont icon-shezhi'></i>,
      },
      ...invitationItem
    ]
    setItems(_items)
  }, [commonStore.userInfo, commonStore.distributorInfo])
	
	const istest: number = window.location.host.includes("webtest") || window.location.host.includes("localhost:300") ? 1 : 0

  const getDistributorInfo = () => {
		accountApi.getDistributorInfo().then((res: any) => {
			if(res.code === 1) {
				setCommonStore({value: res.data, type: 'distributorInfo'})
			}
		})
	}
  const getUserInfo = () => {
    accountApi.getUserInfo().then((res: any) => {
      if(res.code === 1) {
        res.data.company = res.data.reg_company_name
        localStorage.setItem('uid', res.data.uid)
        setCommonStore({value: res.data, type: 'userInfo'})
      }
    })
  }
  const getIsCst = () => {
	  accountApi.getIsCst().then((res: any) => {
	    if(res.code === 1) {
				setCommonStore({value: res.data.is_cst, type: 'isCst'})
        let shop_discount = res.data && res.data.shop_discount ? res.data.shop_discount : 0
        setCommonStore({
          type: 'shop_discount',
          value: shop_discount
        })
	    }
	  })
	}
  const goTo = (key: string) => {
    navigate(key)
    setSelectedKeys([key])
  }
  
  return (
    <div style={{ width: '100%' }}>
    <div className={styles['mine']}>
      <div className="flex">
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                /* 这里是你的组件 token */
                itemActiveBg: colorPrimary,
                itemSelectedBg: colorPrimary,
                itemSelectedColor: '#ffffff'
              },
            },
          }}
        >
          <Menu
            style={{ width: window.localStorage.getItem("lang") === 'zh' ? 160 : 225, marginRight: 10 }}
            selectedKeys={selectedKeys}
            items={items.filter((it: any) => !isCst || !it.cstnot)}
            onClick={(e: any) => goTo(e.key)}
          />
        </ConfigProvider>
        <div 
          className="flex-1" 
          style={{ 
            background: '#fff', 
            minHeight: 'calc(100vh - 400px)', 
            width: window.localStorage.getItem("lang") === 'zh' ? 'calc(100% - 170px)' : 'calc(100% - 235px)' 
          }}>
          <Outlet/>
        </div>
      </div>
      
      
    </div>
    </div>
  )
}

export default Mine